import { FC, ReactNode } from 'react';
import { ListGroup } from 'react-bootstrap';

const Item: FC<{ onClick?: () => void; children: ReactNode }> = ({
  onClick,
  children,
}) => {
  return (
    <ListGroup.Item
      onClick={onClick}
      className="d-flex justify-content-between"
      style={{ cursor: 'pointer' }}
    >
      {children}
    </ListGroup.Item>
  );
};

export default Item;
